import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)({
    height: "100%",
    minHeight: 0,
    display: "block",
    overflow: "hidden",
    borderRadius: 16,
})

export default TicketAdvancedLayout;
